export default __webpack_public_path__ + "static/media/portfolio-tttr.6c125bb1.png";